import { render, staticRenderFns } from "./ApplicationSidebar.vue?vue&type=template&id=86385894&scoped=true"
import script from "./ApplicationSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApplicationSidebar.vue?vue&type=style&index=0&id=86385894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86385894",
  null
  
)

export default component.exports